import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose} from '@angular/material/dialog';
import {BehaviorSubject, Observable} from "rxjs";
import {FlexModule} from "@angular/flex-layout";
import {MatIcon} from "@angular/material/icon";
import {MatButton} from "@angular/material/button";
import {AsyncPipe} from "@angular/common";

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [
    FlexModule,
    MatIcon,
    MatButton,
    MatDialogClose,
    AsyncPipe
  ]
})
export class ConfirmationDialogComponent {

  loading$: Observable<boolean> = new BehaviorSubject<boolean>(false).asObservable();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      message: string,
      buttonConfirmDisabled: boolean,
      buttonConfirmLabel: string,
      buttonCancelDisabled: boolean,
      buttonCancelLabel: string,
      loading$?: Observable<boolean>
    }) {
    if (data?.loading$) {
      this.loading$ = data.loading$;
    }
  }
}
